import { useMemo } from "react";
import { sortBy } from "lodash";

export default (assetTypeMakes: array, distinctMakes: array) => {
    const makes = useMemo(() => {
        const ids = distinctMakes.map((item) => item.id);
        const sortedMakes = sortBy(assetTypeMakes, (item) => item.name);
        return [
            ...sortedMakes.filter((item) => ids.includes(item.id)),
            ...sortedMakes.filter((item) => !ids.includes(item.id)),
        ];
    }, [assetTypeMakes, distinctMakes]);

    return makes;
};
